import SliderBar from './slider-bar';

export default SliderBar;
